import { z } from 'zod';

export const instagramUsernameValidation = z
  .string()
  .trim()
  .min(4, { message: 'Provide min 4 chars' })
  .nonempty({ message: 'Please provide username' })
  .regex(
    new RegExp(/^(?!https|www|instagram.com).*$/),
    'Please provide instagram username, url is not valid',
  )
  .regex(new RegExp(/^(?!@).*$/), 'Please provide instagram username without @')
  .regex(/^[a-zA-Z0-9._]+$/, {
    message:
      'Please provide valid instagram username. Allowed special characters are "_" and "."',
  });

// Optional variant used on the About page, where any one of the three social
// profiles is sufficient (enforced server-side via AT_LEAST_ONE_SOCIAL_REQUIRED).
// When the field is non-empty the same handle rules apply; an empty string is
// accepted and submitted as-is.
export const optionalInstagramUsernameValidation = z.union([
  z.literal(''),
  instagramUsernameValidation,
]);
